module.exports = __webpack_public_path__ + "static/media/completed.f632e377.svg";